

// import React, { useState, useEffect, useRef } from "react";
// import { Grid, Checkbox, FormControlLabel, Button, CircularProgress, Typography, Box } from "@mui/material";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SatelliteAltRounded as SatelliteIcon, DirectionsOff as DirectionsOffIcon, FilterListOff as FilterListOffIcon, FilterList as FilterListIcon, ArrowRight as ArrowRightIcon } from "@mui/icons-material";
// import { pink } from "@mui/material/colors";
// import { Interactions, SelectInteraction } from "../Interactions";
// import GetControls from "./ShowControlsAndInteractions/GetControls";
// import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";
// import { DEFAULT_CENTER } from "../Util/Util";
// import MapDataProvider from "../MapData/MapDataProvider";
// import NavigateToPark from "./NavigateToPark";
// import DefaultMap from "./DefaultMap";
// import useDecodedUser from "../../../../../../services/hooks/useDecodedUser";
// import { useNavigate, useLocation } from "react-router-dom";
// import { fromLonLat } from "ol/proj";
// import { GetDataFromApiWithParams, UpdateAndGetResponse } from "../../../../../../services/api/ExecuteApiRequests";

// const ViewUnapprovedSplitAndMerge = () => {
//   const showPopup = true;
//   const location = useLocation();
//   const highlightParcel = location.state?.highlightParcel || null;
//   const parksFromState = location.state?.parks || null; // Get parks from state
//   const skipParkFetch = location.state?.skipParkFetch || false; // Flag to skip fetching
  
//   const decodedUser = useDecodedUser();
//   const navigate = useNavigate();
//   const [center, setCenter] = useState(DEFAULT_CENTER);
//   const [selectedFeature, setSelectedFeature] = useState(null);
//   const [dialogKey, setDialogKey] = useState(0);
//   const previousFeatureIdRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showLegend, setShowLegend] = useState(false);
//   const [showSateliteImage, setShowSateliteImage] = useState(false);
//   const [isParkLoading, setIsParkLoading] = useState(false); // Start as false since we might have data
//   const [parkName, setParkName] = useState("");

//   useEffect(() => {
//     const currentFeatureId = selectedFeature?.[0]?.getId();
//     if (currentFeatureId !== previousFeatureIdRef.current) {
//       setDialogKey(prevKey => prevKey + 1);
//       previousFeatureIdRef.current = currentFeatureId;
//     }
//   }, [selectedFeature]);

//   // Set center based on park data
//   useEffect(() => {
//     const setParkCenter = async () => {
//       if (!highlightParcel) {
//         console.log("No highlight parcel data available");
//         return;
//       }

//       // Get park ID from the row
//       const parkId = highlightParcel.parkeId || highlightParcel.parkId || highlightParcel.park_id;
      
//       if (!parkId) {
//         console.warn("No park ID found in highlightParcel:", highlightParcel);
//         toast.warning("Park ID not found. Using default view.", {
//           position: "top-right",
//           autoClose: 5000,
//         });
//         return;
//       }

//       try {
//         setIsParkLoading(true);
        
//         let parkData = null;
        
//         // FIRST: Check if we have parks data from the parent component
//         if (parksFromState && Array.isArray(parksFromState) && parksFromState.length > 0) {
//           console.log("Using parks data from parent component");
          
//           // Find the specific park in the parks array
//           parkData = parksFromState.find(p => 
//             p.id === parkId || 
//             p.park_id === parkId || 
//             p.parkeId === parkId
//           );
          
//           if (parkData) {
//             console.log("Found park in parent data:", parkData);
//           }
//         }
        
//         // SECOND: If no park data from parent, try to use selectedPark from highlightParcel
//         if (!parkData && highlightParcel.selectedPark) {
//           console.log("Using selectedPark from highlightParcel");
//           parkData = highlightParcel.selectedPark;
//         }
        
//         // THIRD: If we still don't have park data, try to fetch it (but only if skipParkFetch is false)
//         if (!parkData && !skipParkFetch) {
//           console.log("Fetching park data from API for ID:", parkId);
          
//           // Try to fetch from API
//           try {
//             const response = await GetDataFromApiWithParams(`/parks/${parkId}`);
            
//             if (response && Array.isArray(response) && response.length > 0) {
//               parkData = response[0];
//               console.log("Fetched park data:", parkData);
//             }
//           } catch (fetchError) {
//             console.error("Error fetching park:", fetchError);
//           }
//         }
        
//         // If we have park data, extract center coordinates
//         if (parkData) {
//           // Store park name for display
//           setParkName(parkData.name || parkData.park_name || `Park ${parkId}`);
          
//           // Get center coordinates
//           let coordinates = null;
          
//           if (parkData.center_of_park && parkData.center_of_park.coordinates) {
//             coordinates = parkData.center_of_park.coordinates;
//           } else if (parkData.geometry && parkData.geometry.coordinates) {
//             coordinates = parkData.geometry.coordinates;
//           } else if (parkData.center && parkData.center.coordinates) {
//             coordinates = parkData.center.coordinates;
//           } else if (parkData.centroid && parkData.centroid.coordinates) {
//             coordinates = parkData.centroid.coordinates;
//           }
          
//           if (coordinates) {
//             console.log("Park center coordinates:", coordinates);
//             const newCenter = fromLonLat(coordinates);
//             setCenter(newCenter);
//           } else {
//             console.warn("No center coordinates found in park data");
//           }
//         } else {
//           console.warn("No park data available for ID:", parkId);
//         }
//       } catch (error) {
//         console.error("Error setting park center:", error);
//       } finally {
//         setIsParkLoading(false);
//       }
//     };

//     setParkCenter();
//   }, [highlightParcel, parksFromState, skipParkFetch]);

//   const handleApproveImport = () => {
//     navigate("/ApproveMapEdit");
//   };

//   const controls = <GetControls showLegend={showLegend} />;

//   const interactions = (
//     <Interactions>
//       <SelectInteraction setSelectedFeature={setSelectedFeature} showPopup={true} />
//     </Interactions>
//   );

//   const handleLegendToggle = () => setShowLegend(!showLegend);

//   // Show loading only if we're actively fetching park data
//   if (isParkLoading) {
//     return (
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '100vh', 
//         flexDirection: 'column',
//         bgcolor: '#f5f5f5'
//       }}>
//         <CircularProgress size={50} thickness={4} />
//         <Typography variant="h6" sx={{ mt: 3, color: '#555' }}>
//           Loading park data...
//         </Typography>
//         {highlightParcel && (
//           <Typography variant="body2" sx={{ mt: 1, color: '#777' }}>
//             {highlightParcel.operationType === 'SPLIT' ? 'Split' : 'Merge'} Operation ID: {highlightParcel.id}
//           </Typography>
//         )}
//       </Box>
//     );
//   }

//   return (
//     <>
//       <ToastContainer />
//       <Grid container spacing={2} alignItems="center">
//         <Grid item xs={4} md={4}>
//           <NavigateToPark center={center} setCenter={setCenter} />
//         </Grid>
        
//         <Grid item xs={4} md={4} alignContent={"center"} sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
//           {highlightParcel && (
//             <>
//               <Typography variant="h6" color="primary" gutterBottom>
//                 {highlightParcel.operationType === 'SPLIT' ? 'Split Operation' : 'Merge Operation'}
//               </Typography>
//               <Typography variant="body2" color="textSecondary" gutterBottom>
//                 ID: {highlightParcel.id}
//               </Typography>
//               {parkName && (
//                 <Typography variant="subtitle1" color="success.main" sx={{ fontWeight: 'bold', mt: 1 }}>
//                   Park: {parkName}
//                 </Typography>
//               )}
//             </>
//           )}
//           <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={showLegend}
//                   onChange={handleLegendToggle}
//                   sx={{
//                     color: pink[800],
//                     "&.Mui-checked": {
//                       color: pink[600],
//                     },
//                   }}
//                   icon={<FilterListOffIcon />}
//                   checkedIcon={<FilterListIcon />}
//                 />
//               }
//               label={showLegend ? "Hide Legend" : "Show Legend"}
//             />
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={showSateliteImage}
//                   onChange={e => setShowSateliteImage(e.target.checked)}
//                   checkedIcon={<SatelliteIcon />}
//                   icon={<DirectionsOffIcon />}
//                   color="success"
//                 />
//               }
//               label={showSateliteImage ? "Hide Satellite" : "Show Satellite"}
//             />
//           </Box>
//         </Grid>
        
//         {decodedUser &&
//           decodedUser?.department_id?.toUpperCase() === "GIS" &&
//           decodedUser?.role?.toUpperCase() === "HEAD" && (
//             <Grid item xs={4} md={4} sx={{ display: "flex", justifyContent: "flex-end" }} gap={1}>
//               {isLoading ? (
//                 <CircularProgress size={24} />
//               ) : (
//                 <Button
//                   color="success"
//                   endIcon={<ArrowRightIcon sx={{ fill: "white" }} />}
//                   onClick={handleApproveImport}
//                   variant="contained"
//                   disabled={isLoading}
//                 >
//                   Go to Verify / Decline
//                 </Button>
//               )}
//             </Grid>
//           )}
//       </Grid>
      
//       <MapDataProvider>
//         <DefaultMap
//           controls={controls}
//           interactions={interactions}
//           center={center}
//           showPark={true}
//           showBlocks={false}
//           showParcels={true}
//           showInfras={false}
//           showGreenAreas={false}
//           showUnaprovedImports={false}
//           showSateliteImage={showSateliteImage}
//           showMapPreview={true}
//           highlightParcel={highlightParcel}
//         />
//       </MapDataProvider>
      
//       {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
//         <ShowSpatialFeatureDialog
//           key={dialogKey}
//           spatialInfo={selectedFeature[0]?.getProperties()}
//           setShowWhenReady={true}
//         />
//       )}
//     </>
//   );
// };

// export default ViewUnapprovedSplitAndMerge;

// // import React, { useState, useEffect, useRef } from "react";
// // import { Grid, Checkbox, FormControlLabel, Button, CircularProgress, Typography, Box } from "@mui/material";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { SatelliteAltRounded as SatelliteIcon, DirectionsOff as DirectionsOffIcon, FilterListOff as FilterListOffIcon, FilterList as FilterListIcon, ArrowRight as ArrowRightIcon } from "@mui/icons-material";
// // import { pink } from "@mui/material/colors";
// // import { Interactions, SelectInteraction } from "../Interactions";
// // import GetControls from "./ShowControlsAndInteractions/GetControls";
// // import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";
// // import { DEFAULT_CENTER } from "../Util/Util";
// // import MapDataProvider from "../MapData/MapDataProvider";
// // import NavigateToPark from "./NavigateToPark";
// // import DefaultMap from "./DefaultMap";
// // import useDecodedUser from "../../../../../../services/hooks/useDecodedUser";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { fromLonLat } from "ol/proj";

// // const ViewUnapprovedSplitAndMerge = () => {
// //   const showPopup = true;
// //   const location = useLocation();
// //   const highlightParcel = location.state?.highlightParcel || null;
// //   const parksFromState = location.state?.parks || null;
  
// //   const decodedUser = useDecodedUser();
// //   const navigate = useNavigate();
  
// //   // Map view state - ONLY changed by navigation button
// //   const [center, setCenter] = useState(DEFAULT_CENTER);
  
// //   // Selection state - changed by clicking on map
// //   const [selectedFeature, setSelectedFeature] = useState(null);
  
// //   const [dialogKey, setDialogKey] = useState(0);
// //   const previousFeatureIdRef = useRef(null);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [showLegend, setShowLegend] = useState(false);
// //   const [showSateliteImage, setShowSateliteImage] = useState(false);
// //   const [parkName, setParkName] = useState("");

// //   // This effect ONLY runs for dialog, NEVER for map view changes
// //   useEffect(() => {
// //     const currentFeatureId = selectedFeature?.[0]?.getId();
// //     if (currentFeatureId !== previousFeatureIdRef.current) {
// //       setDialogKey(prevKey => prevKey + 1);
// //       previousFeatureIdRef.current = currentFeatureId;
// //     }
// //   }, [selectedFeature]);

// //   // Set initial park center from highlightParcel (only once on load)
// //   useEffect(() => {
// //     const setInitialParkCenter = async () => {
// //       if (!highlightParcel) return;

// //       const parkId = highlightParcel.parkeId || highlightParcel.parkId || highlightParcel.park_id;
      
// //       if (!parkId) return;

// //       try {
// //         // Try to get park data from state first
// //         let parkData = null;
        
// //         if (parksFromState && Array.isArray(parksFromState)) {
// //           parkData = parksFromState.find(p => 
// //             p.id === parkId || p.park_id === parkId || p.parkeId === parkId
// //           );
// //         }
        
// //         // If we have park data, extract center coordinates
// //         if (parkData) {
// //           setParkName(parkData.name || parkData.park_name || `Park ${parkId}`);
          
// //           let coordinates = null;
// //           if (parkData.center_of_park?.coordinates) {
// //             coordinates = parkData.center_of_park.coordinates;
// //           } else if (parkData.geometry?.coordinates) {
// //             coordinates = parkData.geometry.coordinates;
// //           }
          
// //           if (coordinates) {
// //             console.log("Setting initial park center to:", coordinates);
// //             setCenter(fromLonLat(coordinates));
// //           }
// //         }
// //       } catch (error) {
// //         console.error("Error setting initial park center:", error);
// //       }
// //     };

// //     setInitialParkCenter();
// //   }, [highlightParcel, parksFromState]);

// //   const handleApproveImport = () => {
// //     navigate("/ApproveMapEdit");
// //   };

// //   const controls = <GetControls showLegend={showLegend} />;

// //   const interactions = (
// //     <Interactions>
// //       <SelectInteraction 
// //         setSelectedFeature={setSelectedFeature} 
// //         showPopup={true} 
// //       />
// //     </Interactions>
// //   );

// //   const handleLegendToggle = () => setShowLegend(!showLegend);

// //   return (
// //     <>
// //       <ToastContainer />
// //       <Grid container spacing={2} alignItems="center">
// //         <Grid item xs={4} md={4}>
// //           {/* ONLY this component changes the map center */}
// //           <NavigateToPark center={center} setCenter={setCenter} />
// //         </Grid>
        
// //         <Grid item xs={4} md={4} alignContent={"center"} sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
// //           {highlightParcel && (
// //             <>
// //               <Typography variant="h6" color="primary" gutterBottom>
// //                 {highlightParcel.operationType === 'SPLIT' ? 'Split Operation' : 'Merge Operation'}
// //               </Typography>
// //               <Typography variant="body2" color="textSecondary" gutterBottom>
// //                 ID: {highlightParcel.id}
// //               </Typography>
// //               {parkName && (
// //                 <Typography variant="subtitle1" color="success.main" sx={{ fontWeight: 'bold', mt: 1 }}>
// //                   Park: {parkName}
// //                 </Typography>
// //               )}
// //             </>
// //           )}
// //           <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={showLegend}
// //                   onChange={handleLegendToggle}
// //                   sx={{
// //                     color: pink[800],
// //                     "&.Mui-checked": {
// //                       color: pink[600],
// //                     },
// //                   }}
// //                   icon={<FilterListOffIcon />}
// //                   checkedIcon={<FilterListIcon />}
// //                 />
// //               }
// //               label={showLegend ? "Hide Legend" : "Show Legend"}
// //             />
// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={showSateliteImage}
// //                   onChange={e => setShowSateliteImage(e.target.checked)}
// //                   checkedIcon={<SatelliteIcon />}
// //                   icon={<DirectionsOffIcon />}
// //                   color="success"
// //                 />
// //               }
// //               label={showSateliteImage ? "Hide Satellite" : "Show Satellite"}
// //             />
// //           </Box>
// //         </Grid>
        
// //         {decodedUser &&
// //           decodedUser?.department_id?.toUpperCase() === "GIS" &&
// //           decodedUser?.role?.toUpperCase() === "HEAD" && (
// //             <Grid item xs={4} md={4} sx={{ display: "flex", justifyContent: "flex-end" }} gap={1}>
// //               {isLoading ? (
// //                 <CircularProgress size={24} />
// //               ) : (
// //                 <Button
// //                   color="success"
// //                   endIcon={<ArrowRightIcon sx={{ fill: "white" }} />}
// //                   onClick={handleApproveImport}
// //                   variant="contained"
// //                   disabled={isLoading}
// //                 >
// //                   Go to Verify / Decline
// //                 </Button>
// //               )}
// //             </Grid>
// //           )}
// //       </Grid>
      
// //       <MapDataProvider>
// //         <DefaultMap
// //           controls={controls}
// //           interactions={interactions}
// //           center={center}  // This ONLY changes via NavigateToPark
// //           showPark={true}
// //           showBlocks={false}
// //           showParcels={true}
// //           showInfras={false}
// //           showGreenAreas={false}
// //           showUnaprovedImports={false}
// //           showSateliteImage={showSateliteImage}
// //           showMapPreview={true}
// //           highlightParcel={highlightParcel}  // For programmatic highlighting
// //           selectedFeature={selectedFeature}  // For user selection highlighting
// //         />
// //       </MapDataProvider>
      
// //       {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
// //         <ShowSpatialFeatureDialog
// //           key={dialogKey}
// //           spatialInfo={selectedFeature[0]?.getProperties()}
// //           setShowWhenReady={true}
// //         />
// //       )}
// //     </>
// //   );
// // };

// // export default ViewUnapprovedSplitAndMerge;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Grid, Checkbox, FormControlLabel, Button, CircularProgress, Typography, Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { 
  SatelliteAltRounded as SatelliteIcon, 
  DirectionsOff as DirectionsOffIcon, 
  FilterListOff as FilterListOffIcon, 
  FilterList as FilterListIcon, 
  ArrowRight as ArrowRightIcon 
} from "@mui/icons-material";
import { pink } from "@mui/material/colors";
import { Interactions, SelectInteraction } from "../Interactions";
import GetControls from "./ShowControlsAndInteractions/GetControls";
import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";
import { DEFAULT_CENTER } from "../Util/Util";
import MapDataProvider from "../MapData/MapDataProvider";
import NavigateToPark from "./NavigateToPark";
import DefaultMap from "./DefaultMap";
import useDecodedUser from "../../../../../../services/hooks/useDecodedUser";
import { useNavigate, useLocation } from "react-router-dom";
import { fromLonLat } from "ol/proj";

const ViewUnapprovedSplitAndMerge = () => {
  const showPopup = true;
  const location = useLocation();
  const highlightParcel = location.state?.highlightParcel || null;
  const parksFromState = location.state?.parks || null;
  const skipParkFetch = location.state?.skipParkFetch || false;
  
  const decodedUser = useDecodedUser();
  const navigate = useNavigate();
  
  // ===== MAP VIEW STATE =====
  // This ONLY changes via NavigateToPark component or initial load
  const [center, setCenter] = useState(DEFAULT_CENTER);
  const [zoom, setZoom] = useState(16); // Default zoom level
  
  // ===== SELECTION STATE =====
  // This changes when user clicks on features - DOES NOT affect map view
  const [selectedFeature, setSelectedFeature] = useState(null);
  
  // ===== UI STATE =====
  const [dialogKey, setDialogKey] = useState(0);
  const previousFeatureIdRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showLegend, setShowLegend] = useState(false);
  const [showSateliteImage, setShowSateliteImage] = useState(false);
  const [parkName, setParkName] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Update dialog when selected feature changes (for popup)
  useEffect(() => {
    const currentFeatureId = selectedFeature?.[0]?.getId();
    if (currentFeatureId !== previousFeatureIdRef.current) {
      setDialogKey(prevKey => prevKey + 1);
      previousFeatureIdRef.current = currentFeatureId;
    }
  }, [selectedFeature]);

  // Set initial park center from highlightParcel (ONLY ONCE on load)
  useEffect(() => {
    const setInitialParkCenter = async () => {
      if (!highlightParcel || !isInitialLoad) return;

      console.log("Setting initial park center from highlightParcel");

      const parkId = highlightParcel.parkeId || highlightParcel.parkId || highlightParcel.park_id;
      
      if (!parkId) {
        console.warn("No park ID found in highlightParcel");
        setIsInitialLoad(false);
        return;
      }

      try {
        // Try to get park data from state first
        let parkData = null;
        
        if (parksFromState && Array.isArray(parksFromState)) {
          parkData = parksFromState.find(p => 
            p.id === parkId || p.park_id === parkId || p.parkeId === parkId
          );
        }
        
        // If not in state, try selectedPark from highlightParcel
        if (!parkData && highlightParcel.selectedPark) {
          parkData = highlightParcel.selectedPark;
        }
        
        // If we have park data, extract center coordinates
        if (parkData) {
          setParkName(parkData.name || parkData.park_name || `Park ${parkId}`);
          
          let coordinates = null;
          if (parkData.center_of_park?.coordinates) {
            coordinates = parkData.center_of_park.coordinates;
          } else if (parkData.geometry?.coordinates) {
            coordinates = parkData.geometry.coordinates;
          } else if (parkData.center?.coordinates) {
            coordinates = parkData.center.coordinates;
          } else if (parkData.centroid?.coordinates) {
            coordinates = parkData.centroid.coordinates;
          }
          
          if (coordinates) {
            console.log("Setting initial park center to:", coordinates);
            const newCenter = fromLonLat(coordinates);
            setCenter(newCenter);
          }
        }
      } catch (error) {
        console.error("Error setting initial park center:", error);
      } finally {
        setIsInitialLoad(false);
      }
    };

    setInitialParkCenter();
  }, [highlightParcel, parksFromState, isInitialLoad]);

  // Monitor center changes for debugging
  useEffect(() => {
    console.log("🗺️ Map center updated (should only happen on navigation):", center);
  }, [center]);

  // Monitor selected feature changes for debugging
  useEffect(() => {
    if (selectedFeature) {
      console.log("👆 Feature selected - map view unchanged");
    }
  }, [selectedFeature]);

  const handleApproveImport = () => {
    navigate("/ApproveMapEdit");
  };

  const controls = <GetControls showLegend={showLegend} />;

  const interactions = (
    <Interactions>
      <SelectInteraction 
        setSelectedFeature={setSelectedFeature} 
        showPopup={true} 
      />
    </Interactions>
  );

  const handleLegendToggle = () => setShowLegend(!showLegend);

  return (
    <>
      <ToastContainer />
      
      {/* Header Controls - ONLY NavigateToPark changes the map center */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        {/* Navigation Control - ONLY this changes the map view */}
        <Grid item xs={4} md={4}>
          <NavigateToPark center={center} setCenter={setCenter} />
        </Grid>
        
        {/* Title and Info Section */}
        <Grid item xs={4} md={4} sx={{ 
          display: "flex", 
          justifyContent: "center", 
          flexDirection: "column", 
          alignItems: "center" 
        }}>
          {highlightParcel && (
            <>
              <Typography variant="h6" sx={{ color: '#9e9e9e' }} gutterBottom>
                  {highlightParcel.operationType === 'SPLIT' ? 'Split Operation' : 'Merge Operation'}
                </Typography>

                <Typography variant="body2" sx={{ color: '#bdbdbd' }} gutterBottom>
                  ID: {highlightParcel.id}
                </Typography>

                {parkName && (
                  <Typography variant="subtitle1" sx={{ color: '#9e9e9e', fontWeight: 'bold', mt: 1 }}>
                    Park: {parkName}
                  </Typography>
                )}
            </>
          )}
          
          {/* Legend and Satellite Toggles */}
          <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showLegend}
                  onChange={handleLegendToggle}
                  sx={{
                    color: pink[800],
                    "&.Mui-checked": {
                      color: pink[600],
                    },
                  }}
                  icon={<FilterListOffIcon />}
                  checkedIcon={<FilterListIcon />}
                />
              }
              label={showLegend ? "Hide Legend" : "Show Legend"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={showSateliteImage}
                  onChange={e => setShowSateliteImage(e.target.checked)}
                  checkedIcon={<SatelliteIcon />}
                  icon={<DirectionsOffIcon />}
                  color="success"
                />
              }
              label={showSateliteImage ? "Hide Satellite" : "Show Satellite"}
            />
          </Box>
        </Grid>
        
        {/* Verify/Decline Navigation Button */}
        {decodedUser &&
          decodedUser?.department_id?.toUpperCase() === "GIS" &&
          decodedUser?.role?.toUpperCase() === "HEAD" && (
            <Grid item xs={4} md={4} sx={{ display: "flex", justifyContent: "flex-end" }} gap={1}>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <Button
                sx={{ 
                  bgcolor: '#e0e0e0', // Light gray
                  color: '#000000', // Black text for contrast
                  '&:hover': {
                    bgcolor: '#bdbdbd', // Slightly darker on hover
                  },
                  '&:disabled': {
                    bgcolor: '#f5f5f5', // Very light gray when disabled
                    color: '#9e9e9e',
                  }
                }}
                endIcon={<ArrowRightIcon sx={{ fill: "#000000" }} />} // Black icon to match text
                onClick={handleApproveImport}
                variant="contained"
                disabled={isLoading}
              >
                Go to Verify / Decline
              </Button>
              )}
            </Grid>
          )}
      </Grid>
      
      {/* Map Container */}
      <MapDataProvider>
        <DefaultMap
          controls={controls}
          interactions={interactions}
          center={center}        // ONLY changes via NavigateToPark
          zoom={zoom}             // Stable zoom level
          showPark={true}
          showBlocks={false}
          showParcels={true}
          showSheds={true}
          showBuildings={true}
          showRoads={true}
          showGreenAreas={true}
          showOtherInfras={false}
          showImporteds={false}
          showGCPS={false}
          showWasteDisposals={false}
          showWaters={false}
          showPowers={false}
          showCommunications={false}
          showStorages={false}
          showSurveyDatas={false}
          showPlans={false}
          showSateliteImage={showSateliteImage}
          showUnaprovedImports={false}
          parcelsCategory="OCCUP"
          isEditable={false}
          showCoordinate={true}
          showNorth={true}
          showMapPreview={true}
          showScaleLine={false}
          highlightParcel={highlightParcel}  // For programmatic highlighting
          // IMPORTANT: selectedFeature is NOT passed to map props
          // It's only used for the popup dialog
        />
      </MapDataProvider>
      
      {/* Popup Dialog - Shows when feature is selected, but DOES NOT affect map view */}
      {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
        <ShowSpatialFeatureDialog
          key={dialogKey}
          spatialInfo={selectedFeature[0]?.getProperties()}
          setShowWhenReady={true}
        />
      )}
    </>
  );
};

export default ViewUnapprovedSplitAndMerge;